import type {
  ApiBlock,
  BlockType,
  _ApiBlock,
} from '@backmarket/http-api/src/api-specs-content/models/block'

/**
 * Finds all blocks of a given type in a CMS page content blocks array.
 *
 * See `findBlockByType` for why the cast is needed.
 */
export function filterBlocksByType<T extends BlockType>(
  blocks: ApiBlock[] | undefined,
  type: T,
): _ApiBlock<T>[] {
  const matched = blocks?.filter((b) => b.type === type) ?? []

  return matched as _ApiBlock<T>[]
}
